import React from 'react';
import { compose } from 'redux';
import css from './ModalReservation.APP_TARGET.scss';
import { Modal, Button } from 'panamera-react-ui';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const ModalReservation = props => {
    const { title, description, onConfirm, onCancel, intl } = props;

    const translations = {
        certainButton: intl.formatMessage({ id: 'certainButton', defaultMessage: 'Yakin' }),
        noButton: intl.formatMessage({ id: 'noButton', defaultMessage: 'Tidak' })
    };

    const handleConfirm = e => {
        e.preventDefault();
        onConfirm();
    };

    const handleCancel = e => {
        e.preventDefault();
        onCancel();
    };

    return (
        <Modal
            title={ title }
            className={ css.modalAttention }
            onClick={ handleCancel }
        >
            <p className={ css.desc }>
                {description}
            </p>
            <div className={ css.modalActionWrapper } >
                <Button type="primaryBtn" onClick={ handleConfirm } >
                    { translations.certainButton }
                </Button>
                <Button type="btnOutline" onClick={ handleCancel } >
                    { translations.noButton }
                </Button>
            </div>
        </Modal>
    );
};

ModalReservation.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired
};

export default compose(injectIntl)(ModalReservation);
